import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "cableFilled"
const CableFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M19.125 19.875C19.539 19.875 19.875 20.211 19.875 20.625S19.539 21.375 19.125 21.375H16.125C15.71 21.375 15.375 21.039 15.375 20.625S15.71 19.875 16.125 19.875zM14.812 4.125C15.748 4.125 16.49 4.375 17.052 4.807 17.61 5.233 17.933 5.79 18.12 6.307 18.305 6.824 18.366 7.326 18.383 7.689 18.39 7.872 18.389 8.027 18.384 8.138Q18.381 8.222 18.376 8.272L18.375 8.287V12.773C19.855 12.958 21 14.22 21 15.75V17.82C21 18.333 20.583 18.75 20.07 18.75H15.18C14.666 18.75 14.25 18.333 14.25 17.82V15.75C14.25 14.22 15.395 12.958 16.875 12.773V8.208L16.879 8.168 16.881 8.152Q16.882 8.127 16.886 8.072C16.889 7.999 16.89 7.889 16.884 7.757 16.872 7.487 16.827 7.146 16.71 6.817 16.59 6.492 16.41 6.205 16.14 5.997 15.877 5.798 15.47 5.626 14.812 5.626 14.155 5.625 13.748 5.796 13.484 5.998 13.214 6.205 13.034 6.492 12.916 6.818 12.797 7.145 12.753 7.487 12.74 7.757 12.734 7.888 12.736 7.997 12.74 8.071L12.744 8.152 12.745 8.17 12.75 8.209V15.768L12.749 15.81Q12.749 15.858 12.743 15.939C12.737 16.05 12.723 16.2 12.698 16.382 12.648 16.738 12.548 17.227 12.34 17.726 12.133 18.225 11.805 18.766 11.282 19.184 10.748 19.61 10.053 19.875 9.187 19.875S7.627 19.611 7.093 19.184C6.57 18.766 6.242 18.224 6.034 17.726 5.826 17.226 5.726 16.738 5.676 16.381 5.651 16.2 5.638 16.049 5.631 15.94L5.625 15.809V11.226C4.145 11.04 2.999 9.78 2.999 8.25V6.18C2.999 5.667 3.416 5.25 3.929 5.25H8.82C9.334 5.25 9.75 5.667 9.75 6.18V8.25C9.75 9.78 8.605 11.04 7.126 11.226V15.767L7.13 15.85C7.134 15.926 7.143 16.038 7.161 16.174 7.2 16.45 7.275 16.804 7.418 17.15S7.762 17.797 8.03 18.012C8.287 18.217 8.647 18.375 9.187 18.375S10.087 18.217 10.345 18.012C10.613 17.797 10.812 17.494 10.956 17.149 11.1 16.805 11.175 16.449 11.213 16.174 11.232 16.038 11.241 15.926 11.245 15.85Q11.25 15.794 11.25 15.767V8.272Q11.244 8.222 11.241 8.138C11.236 8.027 11.233 7.872 11.241 7.688 11.26 7.325 11.32 6.823 11.506 6.308 11.692 5.79 12.015 5.233 12.572 4.807 13.135 4.376 13.876 4.125 14.812 4.125M7.875 2.625C8.289 2.625 8.625 2.961 8.625 3.375S8.289 4.125 7.875 4.125H4.875C4.46 4.125 4.125 3.789 4.125 3.375S4.46 2.625 4.875 2.625z" />
        </svg>
      }
    </span>
  )
}
export default CableFilledIcon
